import { render, staticRenderFns } from "./ClauseRelation.vue?vue&type=template&id=5a4947e4&scoped=true&"
import script from "./ClauseRelation.vue?vue&type=script&lang=js&"
export * from "./ClauseRelation.vue?vue&type=script&lang=js&"
import style0 from "./ClauseRelation.vue?vue&type=style&index=0&id=5a4947e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4947e4",
  null
  
)

export default component.exports